import type { ComponentNameAndModule } from '@core/jss-proxy';

export { ReviewEntrySectionContainerComponent } from './lib/review-entry-section-container/review-entry-section-container.component';

const loadChildren = () =>
  import('./lib/reviews-lazy.module').then((mod) => mod.ReviewsLazyModule);

const components = [
  'ReviewEntrySection',
  'ReviewScoreWidget',
  'Review',
  'ReviewEntry',
  'ReviewOverview',
];

export const reviewsLazyImports: ComponentNameAndModule[] = components.map(
  (name) => ({ path: name, loadChildren })
);
